import { html5ConfigBlock } from './ap.config';
import { chosen } from '../directives/chosen';
import { ThemeAppService } from '../services/app.service';
import { ThemeService } from './theme.provider';
import { application } from './application.component';
import { loadNg1Module, ngmodule } from '../bootstrap/ngmodule';
import { sidebar } from './sidebar.component';
import { navbar } from './navbar.component';
import { run } from'./app.run';

import {NotifyService} from '../services/notify.service';

/**
 * Setting main app module
 */
const mainAppModule: aboTheme.INgModule = {
  components: {sidebar, navbar, application},
  configBlocks: [html5ConfigBlock],
  runBlocks: [run],
  services:{NotifyService, ThemeAppService},
  providers:{ThemeService},
  directives: {chosen}
};

loadNg1Module(ngmodule, mainAppModule);





// WEBPACK FOOTER //
// ./~/@abosol/theme/src/app/main/index.ts